import { useLocation } from 'react-router-dom';

export const useSiteCreationFolderId = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const siteCreationFolderId = searchParams.get('siteCreationFolderId');

  return siteCreationFolderId;
};
